import { Environment, ENVIRONMENT_TYPES } from '@lx/shared/types';
import { FLYWIRE_DEFAULT_VALUES } from '../constants/flywire.constants';
import { FlywireConfigurationVariables, FlywireModes } from '../types/gateways/flywire-configuration-variables.type';
import { FlywireEnvirnomentVariables } from '../types/gateways/flywire-envirnoment-variables.type';

const getFlywireMode: (env: Environment) => FlywireModes = (env: Environment) => (ENVIRONMENT_TYPES.production === env ? 'production' : 'demo');

export const loadFlywireEnvironmentVariables: <T>(env: FlywireEnvirnomentVariables<T>) => FlywireConfigurationVariables = <T>(
  env: FlywireEnvirnomentVariables<T>,
) => {
  // Can be expanded when payments feature is included in other companies, and they have other variables
  const flywireDefaultValues = FLYWIRE_DEFAULT_VALUES;
  const environmentValues: Partial<FlywireConfigurationVariables<FlywireModes>> = {
    environment: getFlywireMode(env.environment),
    returnUrl: env.FLYWIRE_DEPOSITS_RETURN_URL ?? flywireDefaultValues.returnUrl,
  };
  return Object.assign({}, flywireDefaultValues, environmentValues);
};
